import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const ClassGradebookQuery = graphql.persisted(
  'ClassGradebookQuery',
  graphql(`
    query ClassGradebookQuery($classOfferingId: ID!, $gradebookId: ID!) {
      classOffering(id: $classOfferingId) {
        id
        gradebook(id: $gradebookId) {
          id
          finalized
          currentFinalization { id revision }
          gradebookSummary {
            weighted
            categoryWeightTotal
            uncategorizedAssignmentCount
            students {
              person { id firstName lastName }
              percentage
              letterGrade
              earnedPoints
              possiblePoints
              includedAssignmentCount
              ungradedAssignmentCount
              excusedAssignmentCount
              droppedAssignmentCount
              categories {
                category { id name }
                percentage
                earnedPoints
                possiblePoints
                weight
                effectiveWeight
                weightedContribution
                includedAssignmentCount
                droppedAssignmentIds
              }
            }
          }
        }
      }
    }
  `)
);

export { ClassGradebookQuery };

export function useClassGradebookQuery(classOfferingId?: string, gradebookId?: string) {
  return useQuery(ClassGradebookQuery, {
    variables: { classOfferingId: classOfferingId!, gradebookId: gradebookId! },
    skip: !classOfferingId || !gradebookId,
  });
}
